import React, { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import cn from "classnames";

import Label from "../Label";
import Validation from "../Validation";

import { FormElement, ChangeButton } from "../shared-style";

import messages from "./messages";
import { StyledInput } from "./styles";
import { IProps } from "./interfaces";

const InputNumber = ({
    label,
    value,
    onChange,
    disabled,
    name,
    changeModal,
    validation,
    lightWithValue,
    required,
    selectAllOnMount,
    focusOnMount,
    placeholder,
    onBlur,
}: IProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (selectAllOnMount || focusOnMount) {
            inputRef!.current!.focus();
        }
    }, []);
    return (
        <FormElement>
            {label && (
                <Label disabled={disabled} required={required}>
                    {label}
                </Label>
            )}
            {validation && <Validation validation={validation} />}
            {changeModal && (
                <ChangeButton onClick={() => changeModal(name, value)}>
                    <FormattedMessage {...messages.modify} />
                </ChangeButton>
            )}
            <StyledInput
                className={cn(
                    validation && "ValidationState",
                    lightWithValue && value !== undefined && "ElementLight"
                )}
                pattern="\d*"
                type="number"
                value={value === undefined ? "" : value}
                onChange={onChange}
                ref={inputRef}
                disabled={disabled}
                name={name}
                placeholder={placeholder}
                onBlur={onBlur}
            />
        </FormElement>
    );
}

export default InputNumber;
